import { useCallback } from 'react';
import {
  AppDependencyGraphContext,
  DependencyGraphProvider,
} from '../../../../context/DependencyGraphProvider';
import type { DependencyGraphProviderProps } from '../../../../context/DependencyGraphProvider/types';
import useInterfaceEventBus from '../../../../hooks/useInterfaceEventBus';
import { useInterfaceAppStore } from '../../../../stores/InterfaceStore';
import { useGetEntityListForApp } from '../hooks/useGetEntityListForApp';

function AppDependencyGraphProvider(
  props: React.PropsWithChildren<
    Omit<
      DependencyGraphProviderProps,
      'getEntityListForDependencyGraphProvider' | 'shouldUseBuiltDependencies'
    >
  >,
) {
  const { getEntityListForApp } = useGetEntityListForApp();
  const interfacePage = useInterfaceAppStore().hooks.page.useDetails();
  const { interfaceEventBus } = useInterfaceEventBus();

  const notifyExternalDependencies = useCallback(
    (id: string) => {
      interfaceEventBus.publish('onInterfaceAppStateChange', { id });
    },
    [interfaceEventBus],
  );

  return (
    <DependencyGraphProvider
      {...props}
      ContextComponent={AppDependencyGraphContext}
      getEntityListForDependencyGraphProvider={getEntityListForApp}
      interfacePage={interfacePage}
      notifyExternalDependencies={notifyExternalDependencies}
      shouldUseBuiltDependencies={false}
    />
  );
}

export default AppDependencyGraphProvider;
